import './DisclosureModal.scss';
import React, { useState } from 'react';

import {
  AAMBeaconModal,
  AAMBeaconButton
} from 'components/shared/Beacon';

const DisclosureModal = ({ title, modalContent, linkContent, sectionalLink=false, link = null, costBasis = false, sweep = false, icon, closeOnClickOut, children, size = 'normal', dataTestId = "" }) => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  }
  const handleClick = () => {
    setShowModal(true);
  }

  return (
    <div className="beacon-disclosure-modal-container">
      {showModal &&
        <AAMBeaconModal size={size}
                     id="disclosure-content-modal"
                     title={title}
                     open={true}
                     description={modalContent}
                     onBeaconEventClose={handleClose}
                     closeOnClickOut={closeOnClickOut}>
                       {children}
        </AAMBeaconModal>
      }
      {linkContent && icon && link && !sectionalLink &&
          <AAMBeaconButton className="beacon-disclosure-modal-link-trigger"
                           variant="tertiary"
                           scale='normal'
                           aria-label="disclosure modal icon trigger"
                           data-testid="beacon-disclosure-modal-link-trigger"
                           link-href={link}>
            {linkContent}
            {icon}
          </AAMBeaconButton>
      }
      {linkContent && icon && link && sectionalLink &&
          <div className='beacon-disclosure-modal-link-trigger flexDiv'>
              <span className='alignCenter'>
                {title}
                <a className='linkText' href={link}>{linkContent}</a>
              </span>
              <div slot='icon'>{icon}</div>
          </div>
      }
      {icon && !linkContent && !link &&
        <AAMBeaconButton className="beacon-disclosure-modal-icon-trigger"
                         variant="tertiary"
                         scale='normal'
                         aria-label="disclosure modal icon trigger"
                         data-testid={`beacon-disclosure-modal-icon-trigger${dataTestId && "-"+dataTestId}`}
                         onBeaconEventClick={handleClick}>
            {icon}
        </AAMBeaconButton>
      }
      {linkContent && !icon && !link &&
        <AAMBeaconButton className="beacon-disclosure-modal-link-trigger"
                         variant="tertiary"
                         scale='normal'
                         aria-label="disclosure modal icon trigger"
                         data-testid="beacon-disclosure-modal-link-trigger"
                         onBeaconEventClick={handleClick}>
          {linkContent}
        </AAMBeaconButton>
      }
      {linkContent && icon && !link && !sweep &&
        <AAMBeaconButton className={costBasis? "beacon-cost-basis-disclosure-modal" : "beacon-disclosure-modal-link-trigger"}
                         variant="tertiary"
                         scale='normal'
                         aria-label="disclosure modal icon trigger"
                         data-testid="beacon-disclosure-modal-link-trigger"
                         onBeaconEventClick={handleClick}>
          {linkContent}
          {icon}
        </AAMBeaconButton>
      }
      {linkContent && icon && !link && sweep &&
          <AAMBeaconButton
              className={'beacon-disclosure-modal-link-trigger'}
              variant="secondary"
              scale='normal'
              aria-label="disclosure modal icon trigger"
              data-testid="beacon-disclosure-modal-link-trigger"
              onBeaconEventClick={handleClick}>
              {linkContent}
              {icon}
          </AAMBeaconButton>
      }
    </div>
  );
};

export default DisclosureModal;